import React, { useEffect, useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import makeStyles from "@material-ui/core/styles/makeStyles";
import DataService from "../../../../../Service";
import Container from "@material-ui/core/Container";
import Button from "@material-ui/core/Button";
import { AddCircleOutlineOutlined } from "@material-ui/icons";
import FlowArrow from "../../../../../Images/FlowArrow.svg";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Loader from "../../../../../Components/Loader";
import CustomSelect from "../../../../../Components/CustomSelect";
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../../../../Components/Snackbar/SnackbarActions";
import { programInfo } from "../../../../../Common/constant";

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: "3rem",
    marginLeft: "10px",
    marginRight: "10px",
  },
  subItems: {
    position: "relative",
    background: "#92bbbf",
    outlineOffset: "2px",
    border: `2px solid ${theme.palette.primary.main} !important`,
    borderRadius: "10px",
    "&:not(:last-child):after": {
      content: "''",
      background: `url(${FlowArrow}) no-repeat`,
      position: "absolute",
      left: "110%",
      top: "50%",
      transform: "translateY(-50%)",
      width: "40px",
      height: "40px",
      backgroundSize: "contain",
      backgroundPosition: "center",
    },
  },
  verticalSubItems: {
    position: "relative",
    background: theme.palette.primary.main,
    borderRadius: "15px",
    border: "2px solid #92bbbf !important",
    "&:not(:last-child):after": {
      content: "''",
      background: `url(${FlowArrow}) no-repeat`,
      transform: "rotate(90deg)",
      backgroundSize: "contain",
      backgroundPosition: "center",
      position: "absolute",
      width: "40px",
      top: "108%",
      height: "40px",
      left: "45px",
    },
  },
  bottomBar: {
    boxShadow: "0px 0px 6px #232323",
    padding: "15px",
    textAlign: "center",
    margin: "0 -24px",
    marginTop: "10px",
    position: "fixed",
    bottom: "0",
    left: "0",
    right: "0",
    zIndex: 1075,
    backgroundColor: "#fff",
  },
  buttonCss: {
    textTransform: "capitalize",
    width: "128px",
    // height: '40px',
    fontWeight: 900,
    fontSize: "14px",
    fontFamily: "Open Sans",
    lineHeight: "16px",
    height: "35px",
  },
  sessionButton: {
    textTransform: "inherit",
    whiteSpace: " noWrap",
    fontSize: "14px",
    fontFamily: "Open Sans",
    lineHeight: "16px",
    height: "35px",
  },
  dragDropContextStyle: {
    width: "0%",
    border: "2px solid #656565",
    padding: "25px",
    background: "#f2f2f2",
  },
}));

const ProgrammeFlowSetup = (props) => {
  const [loading, setLoading] = useState(false);
  const [nextButtonLoading, setNextButtonLoading] = useState(false);
  const [manageModal, setManageModal] = useState(undefined);
  const [inputValue, setInputValue] = useState("");
  const [dropdownValue, setDropdownValue] = useState("");
  const [totalCoachingHourData, setTotalCoachingData] = useState(0);
  const [usedCoachingHourData, setUsedCoachingData] = useState(0);
  const { currentSelection } = props;
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [submitClickFlag, setSubmitClickFlag] = React.useState(false);
  const dispatch = useDispatch();
  const timeDuration = ["hour", "hours", "minute", "minutes"];

  // console.log("program props", currentSelection, props);
  const pageData = data;
  // console.log(pageData, "paEdATA");
  const totalTime = {};
  pageData?.map(
    (content) =>
      (totalTime[content.programme_info_module_id] =
        +content?.duration.split(" ")[0])
  );

  const withoutSequencePageData = pageData
    ?.filter((e) => e?.sequence?.length <= 0)
    .map((e) => e.programme_info_module_id);
  // console.log("ksdsd", withoutSequencePageData);
  let totalSequenceTime = {};

  pageData?.map((e) => {
    if (e?.sequence?.length) {
      let durationArray = e?.sequence?.map((e) => {
        let d = 0;
        if (e.duration.split(" ")[1] === "minutes") {
          d = +e.duration.split(" ")[0] / 60;
        } else {
          d = +e.duration.split(" ")[0];
        }
        return d;
      });
      let spentTime = durationArray?.reduce((sum, seq) => sum + seq, 0);
      totalSequenceTime[e.programme_info_module_id] = spentTime;
    } else {
      //   if (e.duration.split(" ")[1] === "minutes") {
      //     totalSequenceTime[e.programme_info_module_id] =
      //       +e.duration.split(" ")[0] / 60;
      //   } else {
      totalSequenceTime[e.programme_info_module_id] = 0;
      //   }
    }
  });

  useEffect(() => {
    props?.setStepperData("Program flow setup");
    props?.setHeaderType("");
    fetchProgramFlowSetup();
  }, []);

  const fetchProgramFlowSetup = () => {
    setLoading(true);
    DataService.getData(
      { master_template_id: currentSelection?.id },
      "program_flow_setup"
    )
      .then((res) => {
        if (res?.success) {
          // console.log("res", res);
          setLoading(false);
          let mainData = [...res.data, ...res?.new_pgm_data];
          mainData?.map((item) => {
            if(item?.sequence){
            item?.sequence?.map((dd) => {
              dd.id = Math.floor(Math.random() * (100 - 1 + 1) + 1);
            });
          }
          });
          setData(mainData);
        }
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const reorder = (list, source, destination) => {
    const result = Array.from(list);
    const droppableSourceArrayIndex = source?.droppableId.split("_")[1];
    const droppableDestinationArrayIndex =
      destination?.droppableId.split("_")[1];

    const droppableSourceIndex = source?.index;
    const droppableDestinationIndex = destination?.index;

    if (
      result[+droppableSourceArrayIndex]?.sequence[droppableSourceIndex]?.isNew
    ) {
      if (droppableSourceArrayIndex !== droppableDestinationArrayIndex) {
        dispatch(
          showSnackbar("error", [
            "You can not drop new added session outof group!",
          ])
        );
        return result;
      }
    } else {
      if (
        parseInt(
          result[+droppableSourceArrayIndex]?.programme_info_module_id
        ) ===
        parseInt(
          result[+droppableSourceArrayIndex]?.sequence[droppableSourceIndex]
            ?.programme_info_module_id
        )
      ) {
        if (droppableSourceArrayIndex !== droppableDestinationArrayIndex) {
          dispatch(
            showSnackbar("error", [
              "You can not drop existing added session outof group!",
            ])
          );
          return result;
        }
      }
    }
    if (!droppableDestinationArrayIndex || !droppableSourceArrayIndex) {
      if (droppableDestinationArrayIndex) {
        const destinationId = result[+droppableDestinationArrayIndex]?.id;
        let count = 0;
        if (
          ["minute", "minutes"].includes(
            result[droppableSourceIndex].duration?.split(" ")[1]
          )
        ) {
          count =
            usedCoachingHourData[destinationId] +
            parseInt(result[droppableSourceIndex].duration?.split(" ")[0]);
        } else {
          count =
            usedCoachingHourData[destinationId] +
            parseInt(result[droppableSourceIndex].duration?.split(" ")[0]) * 60;
        }
        const totalCount = totalCoachingHourData[destinationId];
        if (count > totalCount) {
          setManageModal(false);
          dispatch(
            showSnackbar("error", [
              "You have exceeded the available session hours!",
            ])
          );
          return result;
        }

        result[droppableDestinationArrayIndex]?.sequence?.splice(
          droppableDestinationIndex,
          0,
          result[droppableSourceIndex]
        );
        result?.splice(droppableSourceIndex, 1);
      } else if (droppableSourceArrayIndex) {
        const [removed] = result[droppableSourceArrayIndex]?.sequence?.splice(
          droppableSourceIndex,
          1
        );
        result?.splice(droppableDestinationIndex, 0, removed);
      } else if (
        !droppableDestinationArrayIndex &&
        !droppableSourceArrayIndex
      ) {
        const [removed] = result?.splice(droppableSourceIndex, 1);
        result?.splice(droppableDestinationIndex, 0, removed);
      }
    } else {
      const [removed] = result[droppableSourceArrayIndex]?.sequence?.splice(
        droppableSourceIndex,
        1
      );
      result[droppableDestinationArrayIndex]?.sequence?.splice(
        droppableDestinationIndex,
        0,
        removed
      );
    }
    return result;
  };

  const handleDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    const newItem = reorder(data, result.source, result.destination);
    setData([...newItem]);
  };

  const getItemStyle = (isDragging, draggableStyle, item) => ({
    padding: "0.5rem",
    margin: programInfo.includes(item?.module_name.toLowerCase())
      ? "0 0 55px 0"
      : "0 0 50px 0",
    width: programInfo.includes(item?.module_name.toLowerCase())
      ? "auto"
      : "8rem",
    maxWidth: "fitContent",
    border: "1px solid #232323",
    background: programInfo.includes(item?.module_name.toLowerCase())
      ? "#f2f2f2"
      : "#077F83",
    font: "16px / 24px Open Sans",
    ...draggableStyle,
  });

  const getSubItemStyle = (isDragging, draggableStyle, item) => ({
    padding: "0.5rem",
    display: "block",
    width: "6rem",
    border: "1px solid #232323",
    font: "16px / 24px Open Sans",
    textAlign: "center",
    margin: "0 55px 0 0",
    ...draggableStyle,
  });
  const handleSubmit = (e) => {
    e.preventDefault();
    data.map((dd) => {
      delete dd?.id;
      dd?.sequence?.map((seqData) => {
        delete seqData?.id;
      });
      delete dd?.time_format;
    });
    let obj = {
      master_template_id: currentSelection?.id,
      data,
    };

    if (data.length) {
      setNextButtonLoading(true);
      DataService.updateData(obj, "", "program_flow_setup")
        .then((res) => {
          if (res?.success) {
            setNextButtonLoading(false);
            fetchProgramFlowSetup();
            props.onNextClick();
          }
        })
        .catch((error) => {
          setNextButtonLoading(false);
        });
    } else {
      setNextButtonLoading(true);
      DataService.createData(obj, "create_program_flow")
        .then((res) => {
          if (res?.success) {
            setNextButtonLoading(false);
            fetchProgramFlowSetup();
            props.onNextClick();
          }
        })
        .catch((error) => {
          setNextButtonLoading(false);
        });
    }
  };

  const handleModal = (boolValue) => {
    setManageModal(boolValue);
  };
  const handleChangeData = (event) => {
    setInputValue(event.target.value);
  };
  const handleDurationChange = (value) => {
    setDropdownValue(value);
  };

  const handleInputSubmit = (e) => {
    const enteredTime =
     ( dropdownValue?.value === "hour" ||   dropdownValue?.value === "hours") ? +inputValue : +inputValue / 60;
    if (inputValue && dropdownValue) {
      data.map((data) => {
        if (
          programInfo.includes(data?.module_name.toLowerCase()) &&
          data.id === manageModal
        ) {
          data.sequence?.push({
            isNew: true,
            duration: `${inputValue} ${dropdownValue.value}`,
            programme_info_module_id: data?.programme_info_module_id,
            id: Math.floor(Math.random() * (100 - 1 + 1) + 1),
          });
        
          if (totalTime[manageModal] - (totalSequenceTime[manageModal] + enteredTime) < 0 ) {
            dispatch(
              showSnackbar("error", [
                "You have exceeded the available session hours!",
              ])
            );
          }
          setTimeout(() => {
            dispatch(
              showSnackbar("success", ["New session created successfully"])
            );
          }, 1500);
        } else {
          return null;
        }
      });

      setData(data);
      setManageModal(undefined);
    } else {
      setSubmitClickFlag(true);
    }
  };

  const addSubItemsModal = () => {
    return (
      <Dialog
        open={Boolean(manageModal)}
        fullWidth={true}
        maxWidth={"xs"}
        onClose={() => {
          handleModal(undefined);
        }}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {" "}
          <h2
            style={{
              fontSize: "18px",
              fontFamily: "Open Sans",
              fontWeight: 700,
            }}
          >
            {" "}
            Add sub items
          </h2>
        </DialogTitle>
        <DialogContent>
          <TextField
            error={submitClickFlag && inputValue == "" ? true : false}
            helperText={
              submitClickFlag && inputValue == ""
                ? "Please enter the value.!"
                : ""
            }
            autoFocus
            margin="dense"
            id="item"
            label="Sub items"
            type="number"
            fullWidth
            onChange={handleChangeData}
          />
          <br />
          <br />

          <CustomSelect
            error={submitClickFlag && dropdownValue == "" ? true : false}
            helperText={
              submitClickFlag && dropdownValue == ""
                ? "Please select the value.!"
                : ""
            }
            id="time_format"
            labelText="Select"
            displayEmpty
            variant="outlined"
            itemArr={timeDuration}
            parentcall={handleDurationChange}
          />
        </DialogContent>
        <DialogActions>
          <Button
            disableElevation
            variant="contained"
            onClick={() => {
              handleModal(undefined);
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleInputSubmit}
            disableElevation
            variant="contained"
            color="secondary"
          >
            Add
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  useEffect(() => {
    let totalCoachingData = {};
    let usedCoachingData = {};
    if (data.length) {
      data
        .filter((item) => programInfo.includes(item?.module_name.toLowerCase()))
        .map((coachingSession) => {
          if (["minute", "minutes"].includes(coachingSession.duration))
            totalCoachingData[coachingSession.id] = parseInt(
              coachingSession.duration?.split(" ")[0] || 0
            );
          else
            totalCoachingData[coachingSession.id] = parseInt(
              coachingSession.duration?.split(" ")[0] * 60 || 0
            );
          const coachingSessionHours = coachingSession?.sequence
            ?.map((sequenceItem) => {
              if (
                ["minute", "minutes"].includes(
                  sequenceItem.duration?.split(" ")[1]
                )
              ) {
                return (
                  sequenceItem.duration &&
                  parseInt(sequenceItem.duration?.split(" ")[0] || 0)
                );
              } else
                return (
                  sequenceItem.duration &&
                  parseInt(sequenceItem.duration?.split(" ")[0] * 60 || 0)
                );
            })
            .reduce((partial_sum, a) => partial_sum + a, 0);
          usedCoachingData[coachingSession.id] = coachingSessionHours;
        });
      setUsedCoachingData(usedCoachingData);
      setTotalCoachingData(totalCoachingData);
    }
  }, [JSON.stringify(data)]);

  return (
    <div style={{ marginLeft: "-1.3rem" }}>
      <form onSubmit={handleSubmit} spellCheck="false">
        <Container className={classes.container} maxWidth="xl">
          {loading && <Loader />}
          <DragDropContext
            className={classes.dragDropContextStyle}
            onDragEnd={handleDragEnd}
          >
            <Droppable droppableId="droppable">
              {(provided, snapshot) => (
                <div {...provided.droppableProps} ref={provided.innerRef}>
                  {data.map((item, index) => (
                    <>
                      <Draggable
                        key={`mainItem_${item?.programme_info_module_id}`}
                        draggableId={`mainItem_${item?.programme_info_module_id}`}
                        index={index}
                      >
                        {(provided, snapshot) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={{
                              ...getItemStyle(
                                snapshot.isDragging,
                                provided.draggableProps.style,
                                item
                              ),
                            }}
                            className={classes.verticalSubItems}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: programInfo.includes(
                                  item?.module_name.toLowerCase()
                                )
                                  ? "space-between"
                                  : "left",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <span
                                  style={{
                                    fontSize: "16px",
                                    fontWeight: "600",
                                    color: programInfo.includes(
                                      item?.module_name.toLowerCase()
                                    )
                                      ? "#2f3c3d"
                                      : "#fff",
                                    width: programInfo.includes(
                                      item?.module_name.toLowerCase()
                                    )
                                      ? "fit-content"
                                      : "8rem",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  {item?.module_name}
                                </span>
                                <span
                                  style={{
                                    color: programInfo.includes(
                                      item?.module_name.toLowerCase()
                                    )
                                      ? "#2f3c3d"
                                      : "#fff",
                                    marginBottom: "1rem",
                                  }}
                                >{`${item?.duration || ""}`}</span>
                              </div>

                              {/* {programInfo.includes(
                                item?.module_name.toLowerCase()
                              ) ? (
                                <div>
                                  <Button
                                    disableElevation
                                    size="small"
                                    color="secondary"
                                    className={classes.sessionButton}
                                    onClick={() => {
                                      handleModal(item?.id);
                                      setInputValue("");
                                      setDropdownValue("");
                                    }}
                                    startIcon={<AddCircleOutlineOutlined />}
                                  >
                                    Add session duration
                                  </Button>
                                </div>
                              ) : (
                                <></>
                              )} */}
                            </div>
                            {programInfo.includes(
                              item?.module_name.toLowerCase()
                            ) ? (
                              <Droppable
                                direction="horizontal"
                                droppableId={`droppable_${index}`}
                              >
                                {(provided, snapshot) => (
                                  <div
                                    ref={provided.innerRef}
                                    style={{
                                      display: "flex",
                                    }}
                                    {...provided.droppableProps}
                                  >
                                    {item?.sequence
                                      ?.filter((item) => item.id)
                                      ?.map((sequenceItem, sequenceIndex) => (
                                        <Draggable
                                          key={`subItemKey_${sequenceIndex}_${index}`}
                                          draggableId={`subItemKey_${sequenceIndex}_${index}`}
                                          index={sequenceIndex}
                                        >
                                          {(provided, snapshot) => (
                                            <div
                                              className={classes.subItems}
                                              ref={provided.innerRef}
                                              {...provided.draggableProps}
                                              {...provided.dragHandleProps}
                                              style={{
                                                ...getSubItemStyle(
                                                  snapshot.isDragging,
                                                  provided.draggableProps.style,
                                                  item
                                                ),
                                              }}
                                            >
                                              <div
                                                style={{
                                                  color: "#2f3c3d",
                                                  fontWeight: "600",
                                                  fontSize: "16px",
                                                }}
                                              >
                                                {sequenceItem.module_name || ""}
                                              </div>
                                              <div style={{ color: "#2f3c3d" }}>
                                                {sequenceItem.duration || ""}
                                              </div>
                                            </div>
                                          )}
                                        </Draggable>
                                      ))}
                                    {provided.placeholder}
                                  </div>
                                )}
                              </Droppable>
                            ) : (
                              <></>
                            )}
                          </div>
                        )}
                      </Draggable>
                    </>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
          {manageModal && addSubItemsModal()}
        </Container>
        <div className={classes.bottomBar}>
          <Button
            onClick={() => props.handleClose()}
            className={classes.buttonCss}
            style={{ marginRight: "10px" }}
            disabled={nextButtonLoading}
            type="submit"
            variant="contained"
          >
            Close
          </Button>
          <Button
            className={classes.buttonCss}
            type="submit"
            disabled={nextButtonLoading}
            variant="contained"
            color="secondary"
          >
            Next
          </Button>
        </div>
      </form>
    </div>
  );
};

export default ProgrammeFlowSetup;
